import {mapActions, mapGetters, mapMutations} from 'vuex';
import moment from 'moment'
import {seo} from '@/mixins/seo'
import {camelCase} from "lodash";

export default {
    name: 'events-detail',
    mixins: [seo],
    props: {},
    data() {
        return {
            active: false,
            value: '',
        }
    },
    computed: {
        ...mapGetters({
            currentItem: 'events/currentItem',
            isLoading: 'events/isLoading',
        }),
        formattedDate() {
            return moment(this.currentItem.startDate).format('DD MMMM, YYYY')
        },
        formattedTime() {
            return moment(this.currentItem.startDate).format('HH:mm')
        }
    },
    mounted() {
        this.fetchData({slug: this.$route.params.slug}).then(() => {
            Object.assign(this.seo, this.currentItem.seo.data)
            this.$emit('updateHead')
        })
    },
    methods: {
        ...mapActions({
            fetchData: 'events/GET_LIST_ITEM'
        }),
        ...mapMutations({
            setCurrentItem: 'events/SET_ITEM'
        }),
        setValue(value) {
            this.value = value;
            this.active = false;
        },
        toCamelCase(str) {
            return camelCase(str)
        },
    },
    destroyed() {
        this.setCurrentItem(null)
    }
}
